import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply } from "sources/books/distributionBidSources";
import { config, initialState } from "./formConfig";

class DistributionBidSourceForm extends FormTemplate {
    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { id, name, knowledgeBaseUrl } = this.props.config;
        return (
            <>
                {this.renderField(id)}
                {this.renderField(name)}
                {this.renderField(knowledgeBaseUrl)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <DistributionBidSourceForm {...props} config={config} initialState={{ ...initialState, ...(props.data || {}) }} />
);

export default ConfiguredModal;
